import type { Experiment } from 'types';

/**
 * Which experiments the home overview lists.
 *
 * Live work only: the home screen is a status view, and drafts and ended
 * experiments have their own pages. The desktop and mobile tables previously
 * disagreed on this, the desktop one filtered and the mobile one did not, so
 * the same account showed a different set of rows depending on the viewport.
 */
const OVERVIEW_STATUSES: ReadonlySet<string> = new Set(['Running', 'Deployed']);

export const overviewExperiments = (experiments: readonly Experiment[] | undefined): Experiment[] =>
  (experiments ?? []).filter((experiment) => OVERVIEW_STATUSES.has(experiment.status));
